import type { PropsWithChildren } from "react";

import Button from "@covertree/ui/buttons/Button";
import Box from "@mui/material/Box";

interface Props extends PropsWithChildren {
  fullWidth?: boolean;
  loading?: boolean;
  disabled?: boolean;
  width?: number;
  mt?: number;
  dataTestId?: string;
  id?: string;
}

export const SubmitButton = ({
  fullWidth = true,
  loading = false,
  disabled = false,
  width,
  children,
  mt,
  dataTestId,
  id,
}: Props) => {
  return (
    <Box mt={mt ?? 4} width={width ?? "100%"}>
      <Button
        sx={{ width: "inherit" }}
        type="submit"
        id={id}
        fullWidth={fullWidth}
        loading={loading}
        disabled={disabled}
        data-testid={dataTestId}>
        {children}
      </Button>
    </Box>
  );
};

export default SubmitButton;
